module.exports = __webpack_public_path__ + "static/media/icon-report-high-score-b.25e24c0f.svg";